const Btnslider = ({ direction, moveSlide }) => {
	return (
		<div>
			<button
				onClick={moveSlide}
				className={direction === "next" ? "btn-slide next" : "btn-slide prev"}
			>
				<h2 className="btnclass">{direction === "next" ? ">" : "<"}</h2>
			</button>
		</div>
	);
};

export default Btnslider;
